/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to control a dashboard instance behaviour
 */
define([], () => {
	class InternalAPI {

		/**
		 * @function InternalAPI#reloadFromJSONSpec
		 * @description Reload the dashboard with the given dashboard spec
		 * @param {object} spec the new dashboard spec to load
		 * @param {object} [options] reload options
		 * @param {boolean} [options.isAuthoringMode] true to reload the dashboard in authoring mode, otherwise false
		 * @param {boolean} [options.clearDirtyFlag] true to mark dashboard as clean, otherwise false
		 */
		reloadFromJSONSpec() { }

		/**
		 * @function InternalAPI#getWidgetRegistry
		 * @description Get the widget registry
		 * @return {object} Collection of entries from the widget registry
		 * @example
	{
		widget-identifier: {
			id: 'widget unique identifier',
			label: 'widget display label',
			builtin: true if widget is an builtin widget otherwise false,
			modelClassPath: 'path of the widget model class',
			widget: 'path of the widget class',
			layoutConsumeView: 'path of the widget layout consumption view class',
			layoutAuthoringView: 'path of the widget layout authoring view class',
			disableTitle: true if widget title is not supported, otherwise false,
			createContentNode: true if widget requires a separate div to separate the widget content,
			enableSmarts: true, // need to revise
			ownTitle: false // need to revise
		},
		...
	}
		 */
		getWidgetRegistry() { }

		/**
		 * @function InternalAPI#getDashboardInfo
		 * @description Get the dashboard internal information
		 * @return {object} collection of dashboard information
		 * @example
	{
		boardId: 'CM object identifier of the dashboard',
		searchPath: 'CM object search path',
		type': 'exploration',
		isDirty: true if the dashboard model has changed otherwise false
	}
		 */
		getDashboardInfo() { }

		/**
		 * @function InternalAPI#prepareGlassOptions
		 * @description Modify the given option object to be consumable by Glass
		 * @param {object} option option object
		 * @return {object} option object consumable by Glass
		 */
		prepareGlassOptions() { }

		/**
		 * @function InternalAPI#getCDNUrl
		 * @description Get the dashboard internal CDN root path
		 * @return dashboard internal CDN root path
		 */
		getCDNUrl() { }

		/**
		 * @function InternalAPI#isDevInstall
		 * @description Determine whether the dashboard is currently running in development mode
		 * @return true if dashboard is currently in development mode, otherwise false
		 */
		isDevInstall() { }

		/**
		 * @function InternalAPI#registerDashboardSvc
		 * @description Register a new service to dashboard
		 * @param {object} service new service to register to dashboard
		 */
		registerDashboardSvc() { }

		/**
		 * @function InternalAPI#setPermissions
		 * @description Set the CM object permisssion to the dashboard
		 * @param {object} permission CM object permission response
		 */
		setPermissions() { }

		/**
		 * @function InternalAPI#destroy
		 * @description destroys the dashboard
		 */
		destroy() { }
	}

	return InternalAPI;
});
